export default __webpack_public_path__ + "static/media/illustration_6.e0223e4f.png";